import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import { useFeatureFlags } from '@/api/feature-flags';
import HeaderArrowIcon from '@/assets/icons/HeaderArrowIcon.svg';
import routes from '@/routes/routes.json';
import useMoengageStore from '@/store/moengage';
import { createMoengageEvent } from '@/utils/moengage';

import { useHeaderProducts } from '../../hooks/useNavProducts';
import { useRentPaymentStore } from '../Bills/store';
import { AvailableProducts } from './HeaderData';

const HeaderProductsContainer = ({ activeHeaderTab, onForexSelected }: any) => {
  return (
    <div className="commons-header-container">
      {useHeaderProducts().map((eachProduct: any) => {
        return Object.entries(eachProduct)?.map(([key, values]: any) => {
          return (
            key === activeHeaderTab &&
            values.map((eachValue: any, idx: number) => {
              return (
                <Link
                  href={eachValue.ProductPathName}
                  key={idx}
                  onClick={() => {
                    onForexSelected(eachValue?.MoEngEventName);
                  }}
                >
                  <div className="commons-header-product-card">
                    <h1 className="commons-header-product-title">
                      {eachValue.ProductTitle}
                    </h1>
                    <p className="commons-header-product-info">
                      {eachValue.ProductInfo}
                    </p>
                  </div>
                </Link>
              );
            })
          );
        });
      })}
    </div>
  );
};

export const HeaderWeb = () => {
  const [activeHeader, setActiveHeader] = useState('');
  const { featureFlags, isFlagsFetched } = useFeatureFlags();
  const router = useRouter();
  const routerPathName = router.pathname.split('/')[1];

  //   onClick={() => onClickChangeTab(AvailableProducts.GoldLoan)}
  const [updateActiveBreadCrumb, updatePaymentFor] = useRentPaymentStore(
    (state) => [state.updateActiveBreadCrumb, state.updatePaymentFor]
  );

  const { mobileNumber, glClicked, ncdClicked } = useMoengageStore((state) => {
    return {
      mobileNumber: state.mobileNumber,
      glClicked: state.glClicked,
      ncdClicked: state.ncdClicked,
    };
  });

  const onForexSelected = (serviceType: string) => {
    return createMoengageEvent(`${serviceType}_clicked`, {
      mobile_number: mobileNumber,
      created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      service_type: serviceType,
    });
  };

  return (
    <div className="commons-all-tabs-container">
      {/* Gold Loan */}
      <div
        // onMouseEnter={() => setActiveHeader(AvailableProducts.GoldLoan)}
        // onMouseLeave={() => setActiveHeader("")}
        className="commons-header-tab"
      >
        <Link
          onClick={() => {
            createMoengageEvent(glClicked, {
              created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
              mobile_number: mobileNumber,
            });
          }}
          href={routes.goldLoan}
          id="header_gold-loans"
          type="button"
          className={`commons-header-tab-container ${
            routerPathName === routes.goldLoan.split('/')[1] &&
            'common-new-header-active'
          }`}
        >
          <p className="commons-header-tab-name">Gold Loan</p>
          {/* <Image
            src={HeaderArrowIcon}
            alt=""
            className="commons-header-arrow-icon"
          /> */}
        </Link>

        {/* {activeHeader === AvailableProducts.GoldLoan && (
          <HeaderProductsContainer
            activeHeaderTab={AvailableProducts.GoldLoan}
          />
        )} */}
      </div>
      {/* Digital Gold */}
      <div
        // onMouseEnter={() => setActiveHeader(AvailableProducts.DigitalGold)}
        // onMouseLeave={() => setActiveHeader("")}
        className="commons-header-tab"
      >
        <Link
          href={routes.digitalGoldHome}
          id="header_digital-gold"
          type="button"
          className={`commons-header-tab-container ${
            routerPathName === routes.digitalGoldHome.split('/')[1] &&
            'common-new-header-active'
          }`}
        >
          <p className="commons-header-tab-name">eSwarna Digital Gold</p>

          {/* <Image
            src={HeaderArrowIcon}
            alt=""
            className="commons-header-arrow-icon"
          /> */}
        </Link>
        {/* {activeHeader === AvailableProducts.DigitalGold && (
          <HeaderProductsContainer
            activeHeaderTab={AvailableProducts.DigitalGold}
          />
        )} */}
      </div>
      {/* NCD */}
      {featureFlags.release_ncd && isFlagsFetched && (
        <div className="commons-header-tab">
          <Link
            onClick={() => {
              createMoengageEvent(ncdClicked, {
                created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                mobile_number: mobileNumber,
              });
            }}
            href={routes.ncdHome}
            id="header_ncd"
            type="button"
            className={`commons-header-tab-container ${
              routerPathName === routes.ncdHome.split('/')[1] &&
              'common-new-header-active'
            }`}
          >
            <p className="commons-header-tab-name">NCD</p>
          </Link>
        </div>
      )}
      {/* Forex */}
      <div
        onMouseEnter={() => setActiveHeader(AvailableProducts.Forex)}
        onMouseLeave={() => setActiveHeader('')}
        className="commons-header-tab"
      >
        <Link
          href={routes.forex}
          id="header_forex"
          type="button"
          onClick={() => onForexSelected('buy_forex')}
          className={`commons-header-tab-container ${
            routerPathName === routes.forex.split('/')[1] &&
            'common-new-header-active'
          }`}
        >
          <p className="commons-header-tab-name">Forex</p>
          <Image
            src={HeaderArrowIcon}
            alt=""
            className="commons-header-arrow-icon"
          />
        </Link>
        {activeHeader === AvailableProducts.Forex && (
          <HeaderProductsContainer
            activeHeaderTab={AvailableProducts.Forex}
            onForexSelected={onForexSelected}
          />
        )}
      </div>
      {/* Payments */}
      {featureFlags.release_rv && isFlagsFetched && (
        <div
          onMouseEnter={() => setActiveHeader(AvailableProducts.Payments)}
          onMouseLeave={() => setActiveHeader('')}
          className="commons-header-tab"
        >
          <Link
            href={routes.billsLanding}
            id="header_bills"
            className={`commons-header-tab-container ${
              routerPathName === routes.billsLanding.split('/')[1] &&
              'common-new-header-active'
            }`}
            onClick={() => {
              updateActiveBreadCrumb('');
              updatePaymentFor('');
            }}
          >
            <p className="commons-header-tab-name">Payments</p>
            <Image
              src={HeaderArrowIcon}
              alt=""
              className="commons-header-arrow-icon"
            />
          </Link>
          {activeHeader === AvailableProducts.Payments && (
            <HeaderProductsContainer
              activeHeaderTab={AvailableProducts.Payments}
              onForexSelected={onForexSelected}
            />
          )}
        </div>
      )}
      {/* MSME */}
      {/* <div className="commons-header-tab">
        <Link
          href="/msme"
          id="header_msme"
          className="commons-header-tab-container"
        >
          <p className="commons-header-tab-name">MSME</p>
        </Link>
      </div> */}
      {/* Blogs */}
      <div className="commons-header-tab">
        <Link
          href={routes.blogs}
          id="header_blogs"
          className={`commons-header-tab-container ${
            routerPathName === routes.blogs.split('/')[1] &&
            'common-new-header-active'
          }`}
        >
          <p className="commons-header-tab-name">Blogs</p>
        </Link>
      </div>
      {/* Careers */}
      <div className="commons-header-tab">
        <Link
          href={routes.careers}
          id="header_careers"
          className={`commons-header-tab-container ${
            routerPathName === routes.careers.split('/')[1] &&
            'common-new-header-active'
          }`}
        >
          <p className="commons-header-tab-name">Careers</p>
        </Link>
      </div>
    </div>
  );
};
